import { Home, AudioPlayer, TVPlayer } from './pages'

const fetchData = () => {
  const brands = fetch('https://bff-tv-guacamole.musicradio.com/v1/brands/').then(response =>
    response.json()
  )
  const videochannels = fetch(
    'https://bff-tv-guacamole.musicradio.com/v1/videochannels/'
  ).then(response => response.json())

  return Promise.all([brands, videochannels])
    .then(([brandData, videoData]) => {
      return {
        brands: brandData.data.brands,
        videochannels: videoData.data.videochannels,
      }
    })
    .catch(() => {
      console.log('Fetch error!')
    })
}

export default {
  root: 'home',
  routes: [
    {
      path: 'home',
      component: Home,
      reuseInstance: true,
      on: page => {
        return fetchData().then(data => (page.data = data))
      },
    },
    {
      path: '/brands/:brand',
      component: AudioPlayer,
    },
    {
      path: '/tv/:channel',
      component: TVPlayer,
    },
  ],
}
